import React, { useEffect} from "react";
import { connect } from "react-redux";
import { getOvertimeList } from "../../../../redux/overtime/overtimeState";
import { List } from "antd";
import { formatDateRange } from "utils/index";
import PopupButton from "components/button/PopupButton";
import OvertimeForm from "./OvertimeForm";
import { MODULE_OVERTIME } from "variables/constants";
import { ClipboardClock } from "lucide-react";

const OvertimeTable = ({
	recordList, 
	pagination, 
	doSearch, 
}) => {
  	
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <List
			dataSource={recordList}
			itemLayout="vertical"
			pagination={{
			...pagination,
			showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,
			}}
			renderItem={(item) => {
			const statusKey = item.ots_status_name.toLowerCase();
	
			return (
				<List.Item key={item.ots_id} className="!p-0 !border-0 mt-2">
					<div className="p-4 border border-slate-200 rounded-xl hover:shadow-md dark:hover:shadow-lg  dark:hover:shadow-white/20 transition-all">
						<div className="flex items-center justify-between">
						<div>
							<div className="flex items-center gap-1 font-semibold text-sm tracking-wide dark:text-white">
								
								<span>
									{formatDateRange(item?.date_time_start, null, null, true, true)}
								</span>
								<span> – </span> 
								<span>
									{formatDateRange(item?.date_time_end, null, null, true, true)}
								</span>
								<span>•</span> 
								<span>{item?.ots_status_id === 67 
										? item?.approved_duration_string
										: item?.duration_string 

									}
								</span>
							</div>
							<div className="text-xs text-slate-700 flex items-center gap-1 tracking-wide">
								<span className="dark:text-white/70">Date Filed: {formatDateRange(item?.created_at)}</span>
							</div>
						</div>
		
					<div className="flex">
						<span className={`status-indicator ${statusKey}`}>
							{item.ots_status_name}
						</span>
						{item.ots_status_id === 66 && (
							<PopupButton
								id={`edit_overtime_${item.ots_id}`}
								label="Edit"
								title="Edit Overtime"
								icon={ClipboardClock}
								btnClass="ml-2 text-xs font-medium text-blue-500 hover:text-blue-700 px-2 py-1 border border-blue-500 rounded hover:bg-blue-50 dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-900 transition"
								moduleId={MODULE_OVERTIME}
								action="edit"
								useCustomClass={true}
							>
							{({ closeModal }) => (
								<div className="max-h-[80vh] overflow-y-auto">
								<OvertimeForm
									recordId={item.ots_id}
									mode="edit"
									onCancel={closeModal}
								/>
								</div>
							)}
							</PopupButton>
						)}
					</div>

						</div>
					</div>
				</List.Item>
			);
			}}
		/>
  	);
};

const mapStateToProps = (state) => ({
	recordList: state.overtime.overtimeList?.items,
	pagination: state.overtime.overtimeList?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getOvertimeList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps )(OvertimeTable);
